import { render, staticRenderFns } from "./SigepTabServices.vue?vue&type=template&id=5aa1c9c9"
import script from "./SigepTabServices.vue?vue&type=script&lang=js"
export * from "./SigepTabServices.vue?vue&type=script&lang=js"
import style0 from "./SigepTabServices.vue?vue&type=style&index=0&id=5aa1c9c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports